<template>
  <div>
    <main class="main" role="main">
      <div class="main_con">
        <div class="my_menu">
          <ul>
            <li>
              <div class="alarm_ttl">퍼뮤니티 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="allKnowhow"
                  v-model="notiAllKnowhow"
                  @change="updateAllKnowhow"
                  hidden
                />
                <label for="allKnowhow" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="grey">
              <div class="alarm_ttl">새글 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="knowhow"
                  v-model="notiKnowhow"
                  @change="updateNotification"
                  hidden
                />
                <label for="knowhow" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="grey">
              <div class="alarm_ttl">답글 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="knowhowReply"
                  v-model="notiKnowhowReply"
                  @change="updateNotification"
                  hidden
                />
                <label for="knowhowReply" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="none">
              <div class="alarm_ttl">채팅 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="chat"
                  v-model="notiChat"
                  @change="updateNotification"
                  hidden
                />
                <label for="chat" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="none">
              <div class="alarm_ttl">1:1문의 알림(고객센터)</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="qna"
                  v-model="notiQna"
                  @change="updateNotification"
                  hidden
                />
                <label for="qna" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="none">
              <div class="alarm_ttl">공지사항 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="noti"
                  v-model="notiNoti"
                  @change="updateNotification"
                  hidden
                />
                <label for="noti" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
            <li class="none">
              <div class="alarm_ttl">퍼스소식 알림</div>
              <div class="toggle">
                <input
                  type="checkbox"
                  class="toggle_checkbox"
                  id="perceAlim"
                  v-model="notiPerceAlim"
                  @change="updateNotification"
                  hidden
                />
                <label for="perceAlim" class="toggle_switch pnt">
                  <span class="toggle_btn"></span>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

export default {
  data() {
    return {
      isCreated: false,
      notiAllKnowhow: false,
      notiKnowhow: false,
      notiKnowhowReply: false,
      notiAllFree: false,
      notiFree: false,
      notiFreeReply: false,
      notiChat: false,
      notiQna: false,
      notiNoti: false,
      notiPerceAlim: false,
    };
  },
  computed: {
    ...userMapGetters({ user: userTypes.USER }),
  },
  created() {
    this[userTypes.FETCH_ME]().then(() => {
      this.setNotification();
    });
  },
  watch: {
    notiKnowhow(val) {
      if (val) {
        if (this.notiKnowhowReply) {
          this.notiAllKnowhow = val;
        }
      } else {
        this.notiAllKnowhow = val;
      }
    },
    notiKnowhowReply(val) {
      if (val) {
        if (this.notiKnowhow) {
          this.notiAllKnowhow = val;
        }
      } else {
        this.notiAllKnowhow = val;
      }
    },
    notiFree(val) {
      if (val) {
        if (this.notiFreeReply) {
          this.notiAllFree = val;
        }
      } else {
        this.notiAllFree = val;
      }
    },
    notiFreeReply(val) {
      if (val) {
        if (this.notiFree) {
          this.notiAllFree = val;
        }
      } else {
        this.notiAllFree = val;
      }
    },
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME, userTypes.USER_UPDATE_ME]),
    setNotification() {
      console.log('this.userthis.userthis.userthis.userthis.user');
      console.log(this.user);
      // 기본 알림값 셋팅
      this.notiKnowhow = this.user.notificationKnowhow;
      this.notiKnowhowReply = this.user.notificationKnowhowReply;
      this.notiFree = this.user.notificationFree;
      this.notiFreeReply = this.user.notificationFreeReply;
      this.notiChat = this.user.notificationChat;
      this.notiQna = this.user.notificationQna;
      this.notiNoti = this.user.notificationNoti;
      this.notiPerceAlim = this.user.notificationPerceAlim;

      // 지식인, 자유게시판 알림 값 셋팅
      if (this.notiKnowhow && this.notiKnowhowReply) {
        this.notiAllKnowhow = true;
      }

      if (this.notiFree && this.notiFreeReply) {
        this.notiAllFree = true;
      }
    },
    async updateNotification() {
      const params = [
        { name: 'notificationKnowhow', value: this.notiKnowhow },
        { name: 'notificationKnowhowReply', value: this.notiKnowhowReply },
        { name: 'notificationFree', value: this.notiFree },
        { name: 'notificationFreeReply', value: this.notiFreeReply },
        { name: 'notificationChat', value: this.notiChat },
        { name: 'notificationQna', value: this.notiQna },
        { name: 'notificationNoti', value: this.notiNoti },
        { name: 'notificationPerceAlim', value: this.notiPerceAlim },
      ];
      const payload = new FormData();
      for (const i in params) {
        payload.append(params[i].name.toString(), params[i].value);
      }

      await this[userTypes.USER_UPDATE_ME](payload);
    },
    updateAllKnowhow() {
      this.notiKnowhow = this.notiAllKnowhow;
      this.notiKnowhowReply = this.notiAllKnowhow;
      this.updateNotification();
    },
    updateAllFree() {
      this.notiFree = this.notiAllFree;
      this.notiFreeReply = this.notiAllFree;
      this.updateNotification();
    },
  },
};
</script>
